/**
 * 素材 (収録動画) の動画エディタ取り込みの料金 (計画 video-editor-presentation-import-plan.md §6)。
 *
 * 尺別の 3 区分 (credit_rate_config の video_edit / video-edit-material-import-10m・30m・60m)。
 * 表示専用: 実際の控除額はバックエンドが保存済みの素材行の duration から同じ規則で解決する
 * (BE: backend/services/video_edit/billing.py の MATERIAL_IMPORT_RESOURCE_TYPES と同じ境界・「以下」)。
 */
export const MATERIAL_IMPORT_SERVICE_TYPE = 'video_edit' as const;

const BUCKETS: ReadonlyArray<readonly [number, string]> = [
  [600, 'video-edit-material-import-10m'],
  [1800, 'video-edit-material-import-30m'],
  [3600, 'video-edit-material-import-60m'],
];

/** 素材の長さ (秒) から料金区分の resource_type を決める。60 分超・不明は null (受け付けられない)。 */
export function materialImportResourceType(durationSec: number | null | undefined): string | null {
  if (typeof durationSec !== 'number' || !Number.isFinite(durationSec) || durationSec <= 0) return null;
  const bucket = BUCKETS.find(([limit]) => durationSec <= limit);
  return bucket ? bucket[1] : null;
}

/** 料金一覧と素材の長さから 1 回のポイント数を取る (未設定・0 以下・区分なしは null)。 */
export function materialImportCreditsFor(
  rates: ReadonlyArray<{ service_type: string; resource_type: string; credits_per_unit: number }> | undefined,
  durationSec: number | null | undefined,
): number | null {
  const resourceType = materialImportResourceType(durationSec);
  if (!resourceType) return null;
  const rate = rates?.find((r) => r.service_type === MATERIAL_IMPORT_SERVICE_TYPE && r.resource_type === resourceType);
  const credits = rate ? Number(rate.credits_per_unit) : NaN;
  return Number.isFinite(credits) && credits > 0 ? credits : null;
}
